import gsap from 'gsap';
import EventDispatcher from '../common/EventDispatcher';
import { Global } from '../common/global';

export default class InstructionScreen {
  constructor(camera, canvas) {}
  init() {
    this.proceeded = false;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    document
      .querySelector('#play_game')
      .addEventListener('click', this.onPlayClick.bind(this));
  }
  async loadAudioFileIntoBuffer(url) {
    return fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        // Get the raw binary data as an ArrayBuffer
        return response.arrayBuffer();
      })
      .then((arrayBuffer) => {
        // Asynchronously decode the audio data
        // This is the crucial step that creates the usable AudioBuffer
        return Global.audioContext.decodeAudioData(arrayBuffer);
      })
      .catch((error) => {
        console.error(`Error loading or decoding audio from ${url}:`, error);
        throw error; // Re-throw the error for the calling code to handle
      });
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
    }
  }
  showScreen(data) {
    if (data['screenKey'] !== 'Instructions') return false;

    document.querySelector('#soundBtn').classList.remove('active2');
    document.querySelector('#instruction_screen').classList.add('active');

    gsap.delayedCall(0.0, () => {
      document.querySelector('#instruction_screen').classList.add('active2');
    });

    gsap.delayedCall(0.2, this.animateScreen.bind(this));
    // this.onPlayClick();
  }
  async onPlayClick() {
    if (!this.proceeded) {
      Global.audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      Global.pringlesBuffer = await this.loadAudioFileIntoBuffer(
        'sounds/collect.mp3'
      );
      Global.hit1Buffer = await this.loadAudioFileIntoBuffer('sounds/hit1.mp3');
      Global.hit2Buffer = await this.loadAudioFileIntoBuffer('sounds/hit2.mp3');
      Global.soundEnabled && document.querySelector('#tapAudio').play();
      this.playGame();
    }
  }
  animateScreen() {
    gsap.delayedCall(0, () => {
      document
        .querySelector('#instruction_screen .header')
        .classList.add('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#instruction_screen #icon1')
        .classList.add('active');
    });
    gsap.delayedCall(0.15, () => {
      document
        .querySelector('#instruction_screen #use')
        .classList.add('active');
    });
    gsap.delayedCall(0.2, () => {
      document
        .querySelector('#instruction_screen #icon2')
        .classList.add('active');
    });
    gsap.delayedCall(0.25, () => {
      document
        .querySelector('#instruction_screen #avoid')
        .classList.add('active');
    });
    gsap.delayedCall(0.3, () => {
      document
        .querySelector('#instruction_screen #icon3')
        .classList.add('active');
    });
    gsap.delayedCall(0.35, () => {
      document
        .querySelector('#instruction_screen #collect')
        .classList.add('active');
    });
    gsap.delayedCall(0.4, () => {
      document
        .querySelector('#instruction_screen #icon4')
        .classList.add('active');
    });
    gsap.delayedCall(0.45, () => {
      document
        .querySelector('#instruction_screen #have')
        .classList.add('active');
    });
    gsap.delayedCall(0.5, () => {
      document
        .querySelector('#instruction_screen #play_game')
        .classList.add('active');
    });
  }
  hideScreen() {
    gsap.delayedCall(0, () => {
      document
        .querySelector('#instruction_screen .header')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#instruction_screen #icon1')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#instruction_screen #use')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#instruction_screen #icon2')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#instruction_screen #avoid')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#instruction_screen #icon3')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#instruction_screen #collect')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#instruction_screen #icon4')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#instruction_screen #have')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#instruction_screen #play_game')
        .classList.remove('active');
    });

    gsap.delayedCall(0.5, () => {
      document.querySelector('#instruction_screen').classList.remove('active2');

      gsap.delayedCall(0.5, () => {
        document
          .querySelector('#instruction_screen')
          .classList.remove('active');
      });
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'start_intro',
          data: {},
        },
      });
    });
  }
  playGame() {
    if (this.proceeded) return;

    this.proceeded = true;

    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: 'instructionPlayClick',
      uniqID: Global.U_ID,
    });
    this.hideScreen();
    // document.querySelector('#languageSelection_screen').style.display = 'none';
    // this.events.dispatchEvent({
    //   type: 'USER_EVENTS',
    //   message: {
    //     event_type: 'changeScreen',
    //     data: {
    //       curentScreen: 'instruction_screen',
    //       nextScreen: 'score_screen',
    //     },
    //   },
    // });
    // this.events.dispatchEvent({
    //   type: 'USER_EVENTS',
    //   message: {
    //     event_type: 'leaderboard',
    //     data: {
    //       curentScreen: '',
    //       nextScreen: '',
    //     },
    //   },
    // });
  }
}
